// extracted by mini-css-extract-plugin
module.exports = {"backIcon":"backicon_backIcon__3l160"};